import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=8562aff2&scoped=true&"
import script from "./TaxRates.vue?vue&type=script&lang=js&"
export * from "./TaxRates.vue?vue&type=script&lang=js&"
import style0 from "./TaxRates.vue?vue&type=style&index=0&id=8562aff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8562aff2",
  null
  
)

export default component.exports